import {
    GET_ALL_RAFFLES,
} from '../actions/RaffleActions'

const initialState = {
    data: [],
    latestUpdate: '',
    loading: false,
    error: '',
}

const RaffleReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_ALL_RAFFLES: {
            return {
                ...state,
                data: action.payload,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default RaffleReducer
